/* melee-v2-handlebars.js — migrated out of sections/melee-v2-handlebars.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    /* ---- bar heatmap: play the clip when it scrolls into view, don't
       loop (it holds on the last frame), replay on re-entry ---- */
    function initBarsec(root) {
      if (!root || root.dataset.mv2BarsecReady === '1') return;
      root.dataset.mv2BarsecReady = '1';

      var vid = root.querySelector('[data-mv2-barsec-video]');
      if (!vid) return;

      // reduced motion: leave the poster still, no autoplay
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              try {
                vid.currentTime = 0;
              } catch (e) {}
              var p = vid.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              vid.pause();
              try {
                vid.currentTime = 0;
              } catch (e) {} // arm it to replay on re-entry
            }
          });
        },
        { threshold: 0.35 }
      );

      io.observe(vid);
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-barsec]').forEach(initBarsec);
    }

    ready(initAll);
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-mv2-barsec]') : null;
      if (root) {
        root.dataset.mv2BarsecReady = '0';
        initBarsec(root);
      }
    });
  })();

  /* The shared MV2 scroll-fx engine (the driver behind .mv2-reveal /
     .mv2-parallax / .mv2-zoom-scroll) that used to live here has moved
     to melee-v2-foundation.liquid's inline <script>, rendered once by
     every melee-v2- section instead of being duplicated per file. This
     file now only carries the heatmap-video init logic above. */
